var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('v-select',{attrs:{"items":_vm.items,"prepend-icon":_vm.icon,"label":_vm.label,"hide-details":"","solo-inverted":"","return-object":""},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }